import SpinModel from '../../../vendor_core/core/src/model/SpinModel';
import UIController from '../../../vendor_core/core/src/ui/UIController';
import { UIUpdateEvent } from '../../../vendor_core/core/src/ui/UIUpdateEvents';
import VendorModel from '../../../vendor_core/src/model/VendorModel';
import VendorFinishState from '../../../vendor_core/src/states/VendorFinishState'

export default class MSFinishState extends VendorFinishState {
    protected updateBalance(): void {
        if (SpinModel.inFreegames()) {
            if (VendorModel.freeGames.perSpinPayouts) {
                UIController.updateFields(UIUpdateEvent.Balance);
            }
        } else {
            UIController.updateFields(UIUpdateEvent.Balance);
        }
    }
}
